import React from 'react';
var SnippylyTagTool = function (props) {
    var targetTagElementId = props.targetTagElementId, children = props.children;
    return (React.createElement("velt-tag-tool", { "target-tag-element-id": targetTagElementId }, children));
};
export default SnippylyTagTool;
